import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'

import CarouselLegend from './CarouselLegend'
import { CarouselActionsStyles } from './styles'

export interface CarouselActionsProps {
  onNext: (event?: Event) => void
  onPrev: (event?: Event) => void
  onActive: (index: number) => void
  currentSlide: number
  totalSlides: number
  legendType?: 'dots' | 'numbers'
}

export const CarouselActions = ({
  onNext,
  onPrev,
  currentSlide,
  totalSlides,
}: CarouselActionsProps) => (
  <CarouselActionsStyles>
    <Button
      className="carousel-button"
      size="lg"
      modifier="outline"
      onClick={onPrev}
      aria-label="Slide anterior"
    >
      <Icon icon="angle-left" color="pink" />
    </Button>

    <CarouselLegend currentSlide={currentSlide} totalSlides={totalSlides} />

    <Button
      className="carousel-button"
      size="lg"
      modifier="outline"
      onClick={onNext}
      aria-label="Próximo slide"
      type="button"
    >
      <Icon icon="angle-right" color="pink" />
    </Button>
  </CarouselActionsStyles>
)

export default CarouselActions
